export default "__VITE_ASSET__BiQzj5xw__"